<template>
  <div>
    <div class="optiTANwrapper">
      <optitan-flicker
        id="optiTANFlicker"
        :tan-code="challengeValue"
        :speed="speed"
      />
    </div>
    <a-slider
      v-model="speed"
      :min="1"
      :max="500"
    />
  </div>
</template>

<script>
import Widget from '@/components/layout-components/widgets/Widget'
import _ from 'lodash'

import '@kibro/brezel-optitan'

export default {
  name: 'WidgetOptiTAN',
  extends: Widget,
  data () {
    return {
      speed: 50,
    }
  },
  computed: {
    challengeValue () {
      return _.get(this.component, 'options.hhd_uc_challenge', '')
    },
  },
}
</script>

<style lang="scss" scoped>

.optiTANwrapper {
  display: flex;
  justify-content: center;
}

#optiTANFlicker {
  resize: both;
}
</style>
